import React from 'react';

/**
 * @param {'canvas'|'wash'} variant — alternate section backgrounds per design system
 */
export default function SaasSection({ variant = 'canvas', children, className = '' }) {
  const bg = variant === 'wash' ? 'bg-sky-wash' : 'bg-linen-canvas';
  return (
    <section className={`${bg} py-16 md:py-[var(--section-gap,80px)] ${className}`}>
      {children}
    </section>
  );
}
